import { getContext } from 'svelte';
export function useLocale() {
    return getContext('locale');
}
export async function createLocale(actions) {
    return await new Promise((resolve) => {
        window.addEventListener('message', (event) => {
            if (event.data.action === 'JEWELLERY_BUILDER_COUNTRY') {
                resolve({
                    countryCode: event.data.country,
                    currencyCode: event.data.currency
                });
            }
        });
        actions.ready();
        // Resolve to Australia if we don't get a message:
        setTimeout(() => {
            resolve({ countryCode: 'AU', currencyCode: 'AUD' });
        }, 2000);
    });
}
